var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.fromwechat)?_c('Header',{attrs:{"isFromClass":true,"p_isLogin":_vm.c_isLogin,"p_gotoLogin":_vm.gotoLogin,"p_logout":_vm.logout,"UserInfo":_vm.mg_userInfo,"p_isInCnIframe":_vm.ms_isInCnIframe,"RedirectUrl":_vm.redirectUrl}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }